import AccreditationInviteContainer from './../../components/accreditations/AccreditationInviteContainer.vue'
import BulkPrintContainer from './../../components/builder/BulkPrintContainer.vue'
import CalculationPdf from './../../components/events/calculation-pdf.vue'
import CompensationPdf from './../../components/events/compensation-pdf.vue'
import PrintContainer from './../../components/builder/PrintContainer.vue'
import ReportPdfPage from '../../components/ticket-seller/reports/report-pdf-page.vue'
import CashRegisterStatePdfPage from '../../components/ticket-seller/reports/cash-register-state.vue'
import CompensationTicketSellerAdmin from '../../components/ticket-seller-admin/compensation.vue'
import SummaryPdf from './../../components/events/summary-pdf.vue'
import InvoicePdf from '../../components/invoice/invoice.vue'
import TicketPdfContainer from './../../components/builder/TicketPdf.vue'
import TicketSellerPrintContainer from '../../components/builder/ticket-seller-pdf.vue'
import { allowedUserType } from '@/routing/rules'
import { getPropsFromParams } from '../utils.routing'
import { ticketSellerRouteNames } from '../routeNames/ticketSellerRouteNames'
import { ungroupedRouteNames } from '../routeNames/ungroupedRouteNames'
import ReportPdf from './../../components/ticket-seller-admin/report-pdf-page.vue'
import TheaterEventReport from '@/components/events/theater-event-report'
import MaintenanceScreen from '@/components/maintenance/MaintenanceScreen.vue'
import { AdminRoutes } from '@/routing/routes/admin-routes'

/**
 * Routes used by Router
 *
 * UngroupedRoutes include routes that are not in the same design layout as mainRoutes
 * and are mostly accessed via backend.
 *
 * They are designed for getting PDFs and printing tickets/summaries
 */

export const UngroupedRoutes = [
  {
    path: '/organizations/:organizationSlug/events/:eventId/accreditation/:accreditationId/edit/print',
    name: ungroupedRouteNames.print,
    props: getPropsFromParams,
    component: PrintContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/events/:eventId/accreditations/print',
    name: ungroupedRouteNames.bulkPrint,
    props: getPropsFromParams,
    component: BulkPrintContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/summary',
    name: ungroupedRouteNames.eventSummaryPdf,
    props: getPropsFromParams,
    component: SummaryPdf,
    meta: {
      rules: [allowedUserType(['SUPER_ADMIN', 'REGULAR'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/calculation',
    name: ungroupedRouteNames.calculationPdf,
    props: getPropsFromParams,
    component: CalculationPdf,
    meta: {
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/calculation',
    name: ungroupedRouteNames.calculationPdfSport,
    props: getPropsFromParams,
    component: CalculationPdf,
    meta: {
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventId/report',
    props: getPropsFromParams,
    name: ungroupedRouteNames.theaterEventReport,
    component: TheaterEventReport,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Event report',
    },
  },
  {
    path: '/organizations/:organizationSlug/events/:eventId/compensation',
    name: ungroupedRouteNames.compensationPdf,
    props: getPropsFromParams,
    component: CompensationPdf,
    meta: {
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/sport-organizations/:organizationSlug/events/:eventId/compensation',
    name: ungroupedRouteNames.compensationPdfSport,
    props: getPropsFromParams,
    component: CompensationPdf,
    meta: {
      rules: [allowedUserType(['SUPER_ADMIN'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/ticket-seller-admin/compensation',
    props: getPropsFromParams,
    name: ungroupedRouteNames.compensationPdfTicketSeller,
    component: CompensationTicketSellerAdmin,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/ticket-pdf/:orderUUID/:purchaseIndex',
    name: ungroupedRouteNames.ticketPdf,
    props: getPropsFromParams,
    component: TicketPdfContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  // {
  //   path: '/*',
  //   name: ungroupedRouteNames.maintenanceScreen,
  //   props: getPropsFromParams,
  //   component: MaintenanceScreen,
  //   meta: {
  //     requiresAuthentication: false,
  //     redirectIfAuthenticated: false,
  //   },
  // },
  {
    path: '/ticket-seller/print/:uuid',
    name: ungroupedRouteNames.ticketSellerPrintContainer,
    props: getPropsFromParams,
    component: TicketSellerPrintContainer,
    meta: {
      //  TOMISLAV only ticketseller can access this route
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/accreditation-invite/:inviteToken',
    name: ungroupedRouteNames.inviteAccreditation,
    props: getPropsFromParams,
    component: AccreditationInviteContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/cash-register-state-pdf',
    name: ticketSellerRouteNames.cashRegisterStatePdf,
    props: getPropsFromParams,
    component: CashRegisterStatePdfPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Cash register state Pdf',
    },
  },
  {
    path: '/ticket-seller-report-pdf',
    name: ticketSellerRouteNames.reportPdf,
    props: getPropsFromParams,
    component: ReportPdfPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Report Pdf',
    },
  },
  {
    path: '/invoice/:orderUUID',
    name: ungroupedRouteNames.invoicepdf,
    props: getPropsFromParams,
    component: InvoicePdf,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      title: 'Invoice Pdf',
    },
  },
  {
    path: '/ticket-seller-admin-report-pdf',
    name: ungroupedRouteNames.reportPdfAdmin,
    props: getPropsFromParams,
    component: ReportPdf,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Report Pdf',
    },
  },
  ...AdminRoutes,
]
